export const formatMultiplier = (value: number | undefined): string => {
  if (value === undefined) return '—';
  const trimmed = value
    .toFixed(3)
    .replace(/\.0+$/, '')
    .replace(/\.(\d*?)0+$/, '.$1');
  
return trimmed.includes('.') ? trimmed : `${trimmed}.0`;
};
